import { connect } from 'react-redux';
//
import CompareBoxPlot from 'pages/compare/box-plot/CompareBoxPlot';
import { IStoreState } from 'store';
import { EDisplay } from 'components/deal-results/product-items';
import { ILineGraphItem } from 'store/deal-evaluation/types';
import { getLegendText, getLineGraphItems, getPricePerUnitLabel } from 'store/deal-comparison/selectors';
import { setSelectedDisplay } from 'store/deal-comparison/actions';

export interface ICompareBoxPlotStateProps {
  lineGraphItems: ILineGraphItem[];
  legendText: string;
  selectedDisplay: EDisplay;
  pricePerUnitLabel: string;
}

export interface ICompareBoxPlotDispatchProps {
  setSelectedDisplay: (display: EDisplay) => void;
}

export type TCompareBoxPlotProps = ICompareBoxPlotStateProps & ICompareBoxPlotDispatchProps;

const mapStateToProps = (state: IStoreState): ICompareBoxPlotStateProps => ({
  lineGraphItems: getLineGraphItems(state),
  legendText: getLegendText(state),
  selectedDisplay: state.dealComparison.selectedDisplay,
  pricePerUnitLabel: getPricePerUnitLabel(state),
});

const mapDispatchToProps = {
  setSelectedDisplay,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompareBoxPlot);
